<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
<!--          <Col v-bind="grid">-->
<!--            <FormItem label="文章名称："  label-for="key">-->
<!--              <Input search enter-button placeholder="请输入" clearable v-model="userForm.key" @on-search="userSearchs">-->
<!--              </Input>-->
<!--            </FormItem>-->
<!--          </Col>-->
        </Row>
<!--        <Row type="flex">-->
<!--          <Col>-->
<!--            <Button type="primary"  icon="md-add" @click="add">添加文章</Button>-->
<!--          </Col>-->
<!--        </Row>-->
      </Form>
      <Table :columns="columns2" :data="tableList" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button type="primary" @click="send(row.media_id)">群发送</Button>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
  </div>
</template>

<script>
  import { articleList, sendArticle } from '@/api/wechatArticle'
  export default {
    name: 'articleList',
    data () {
      return {
        userForm: {
          page: 1,
          limit: 10,
          type: 2,
          key: ''
        },
        grid: {
          xs: 24,
          sm: 24,
          md: 12,
          lg: 7,
          xl: 7
        },
        article_id: 0,
        editShow: false,
        confirm: false,
        dataCount: 0,
        max_sort: 0,
        tableList: [],
        loading: false,
        userid: 0,
        columns2: [
          {
            title: '文章编号',
            key: 'media_id',
            minWidth: 80
          },
          {
            title: '文章标题',
            key: "title",
            minWidth: 120
          },
          {
            title: '更新时间',
            key: 'mtime',
            minWidth: 110
          },
          {
            title: '操作',
            slot: 'action',
            fixed: 'right',
            minWidth: 120
          }
        ]
      }
    },
    created () {
      this.articleList()
    },
    methods: {
      articleList () {
        this.loading = true
        articleList(this.userForm).then(res => {
          let data = res.data
          this.tableList = data.list
          this.dataCount = data.count
          this.loading = false
        }).catch(res => {
          this.loading = false
          this.$Message.error(res.msg)
        })
      },
      add () {
        this.$router.push({ path: '/admin/wechatArt/edit/' })
      },
      // 分页
      changepage (status) {
        this.userForm.page = status
        this.articleList()
      },
      handImgurl(url){
        var str = url.replace(/.+\./, "");
        if(str === 'mp4'){
          return url+'?x-oss-process=video/snapshot,t_3000,f_jpg,w_60,m_fast'
        }else{
          return url
        }
      },
      // 表格搜索
      userSearchs () {
        this.userForm.page = 1
        this.articleList()
      },
      selectChange () {
        this.userForm.key = ''
      },
      send (id) {
        //发送
        sendArticle(id).then(async res => {
          this.$Message.success(res.msg)
          this.articleList()
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      },
      updateStatusModel (modalStatus) {
        this.editShow = modalStatus
        this.reload()
      },
      closeModal () {
        this.articleList()
      }
    }
  }
</script>
